import localForage from "localforage";
import { loadPage } from "SiteLayout/CurrentPage/action-creators";
import { updateAppShellData } from "./action-creators";
import { parseUrl, urlToString } from "Shared/url";
import { getJson } from "Shared/server";
import * as crossWindowEvents from "Shared/cross-window-events";
import { replaceState } from "Shared/history";
const requestTimeout = 100;
const storage = localForage.createInstance({
    storeName: "appshell",
});
export const appShellDataUrl = "/appshell/data";
export function nuke() {
    // The catch is because it always fails in private browsing
    return storage.clear().catch(() => null);
}
export function refreshCachedData(store) {
    refreshAppShellData(store);
    persistCartAndWishListChanges(store);
    return refreshCurrentPageData(store);
}
// Note! This shouldn't be used by the main application since the app shell data
// is available in the Redux state.
export function getAppShellData() {
    return Promise.race([
        timeout(),
        storage.getItem(appShellDataUrl),
    ]).then((data) => {
        if (data) {
            return data;
        }
        else {
            return getJson(appShellDataUrl).then((data) => {
                saveAppShellData(data);
                return data;
            });
        }
    });
}
export function saveAppShellData(data) {
    // The catch is because it always fails in private browsing
    return Promise.race([
        timeout(),
        storage.setItem(appShellDataUrl, data).catch(() => null),
    ]);
}
function refreshAppShellData(store) {
    console.info("Reloading app shell since rendered from service worker...");
    store.dispatch(updateAppShellData());
}
function refreshCurrentPageData(store) {
    console.info("Reloading current page since rendered from service worker...");
    const currentUrl = urlToString(parseUrl(window.location));
    return store.dispatch(loadPage(currentUrl));
}
// The cart is one of the things in the app shell data that the user can
// change and we want to persist those changes. Because if the user reloads
// without network connection to refresh the app shell data, the cart should
// still be correct.
function persistCartAndWishListChanges(store) {
    let currentCart = store.getState().cart;
    store.subscribe(() => {
        const newCart = store.getState().cart;
        if (currentCart !== newCart) {
            saveAppShellDataWithNewCartAndWishList(newCart);
            currentCart = newCart;
        }
    });
}
let saveTimer;
function saveAppShellDataWithNewCartAndWishList(cart) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
        storage.getItem(appShellDataUrl).then((data) => {
            console.info("Persisting change to app shell data");
            data.cart = cart;
            saveAppShellData(data);
        });
    }, 200);
}
function timeout() {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(null);
        }, requestTimeout);
    });
}
crossWindowEvents.on("update-appshelldata", (store) => {
    const isLoggedIn = store.getState().currentUser.isLoggedIn;
    store.dispatch(updateAppShellData(false)).then(() => {
        if (isLoggedIn !== store.getState().currentUser.isLoggedIn) {
            replaceState();
        }
    });
});
export function pageHasAppShell(componentName) {
    const pagesWithoutAppShell = [
        "DeliveryApplication",
        "PantryReportPage",
        "SupplierLoginPage",
        "AccountSettingsPage",
        "PunchOutLoginPage",
        "PunchOutTakeoverPage",
    ];
    return !pagesWithoutAppShell.some((pageName) => componentName.indexOf(pageName) >= 0);
}
